import { render, staticRenderFns } from "./default.vue?vue&type=template&id=d1c25ba8&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoginModal: require('/opt/build/repo/frontend2/components/LoginModal.vue').default,Modal: require('/opt/build/repo/frontend2/components/Modal.vue').default})
